module.exports = __webpack_public_path__ + "static/media/sunrise2.6f80aee4.jpg";